import React from "react"
import "./newfooterView.css"
import Heading from "../Heading"
import Link from "gatsby-link"

export class ManifestoPoint extends React.Component {
	constructor (args) {
		super(args)
		this.state = {}
	}
	render () {
		return (
			<div className="section__content">
				<div className="newfooter__wrapper">
					<div className="newfooter__section">
						<div className="">
							<Heading title="Updates" />
						</div>
						<div className="newfooter_content">
							<div className="row">
								<div className="col-lg-4 col-md-4">
									<div className="left_newfooter">
										<div className="card_h">
											<Link to="/insights/holdingmyown">
												<div className="left_card">
													<div className="left_img">
														<img src="https://winpeforum.com/assets/elements/Nupur_Garg_profile_updated_section.jpg" alt="" className="img-responsive" />
													</div>
													<div className="left_heading">Being the Change</div>
													<div className="left_sub_heading">Nupur Garg of Winpe</div>
													<div className="left_type"></div>
													<div className="left_date">Winpe Indights &#8226;6 OCTOBER 2020</div>
												</div>
											</Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-4">
									<div className="mid_newfooter">
										<div className="card_h">
											<div className="top_mid_section">
												<div className="mid_heading">Upcoming Events</div>
												<div className="top_event_sevtion">
													<div className="row">
														<div className="col-lg-8 col-md-8">
															<div className="event_text">Winpe ProClub Mentorship Program: Launch</div>
														</div>
														<div className="col-lg-4 col-md-4">
															<div className="date">6 OCT 2020</div>
														</div>
													</div>
												</div>
												<div className="top_event_sevtion">
													<div className="row">
														<div className="col-lg-8 col-md-8">
															<div className="event_text">Winpe Collegium</div>
														</div>
														<div className="col-lg-4 col-md-4">
															<div className="date">30 SEP 2020</div>
														</div>
													</div>
												</div>
											</div>
											<div className="last_mid_section">
												<div className="mid_heading">Resources</div>
												<div className="last_event_sevtion">
													<div className="event_text">Women in the Workplace</div>
													<div className="event_subtext">McKinsey & Company</div>
													<div className="date">September 2020 | Report </div>
												</div>
												<div className="last_event_sevtion">
													<div className="event_text">Project 3.0: Tracking Venture Capital, Private Equity and Private Debt with a Gender Lens</div>
													<div className="event_subtext">Wharton Social Impact Initiative & Catalyst at Large</div>
													<div className="date">July 2020 | Report</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-4">
									<div className="right_newfooter">
										<div className="card_h">
											<Link to="/press">
												<div className="right_card">
													<div className="right_img">
														<img src="https://winpeforum.com/assets/elements/WinpeProclub_press.jpg" alt="" className="img-responsive" />
													</div>
													<div className="right_heading">Business Standard</div>
													<div className="right_sub_heading">Russell Reynolds Associates and Winpe launch pioneering mentorship program for women in investing</div>
													<div className="right_date">October 2020 | Press Release</div>
												</div>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default ManifestoPoint



// WEBPACK FOOTER //
// ./src/components/NewFooter/index.js